export default __webpack_public_path__ + "static/leed-logo-8a63a4942a599eaf5d4499dd04b16a09.svg";